// ABOUTME: Tailwind CSS breakpoint constants for JS/TS usage
// ABOUTME: Keep in sync with Tailwind v4 default breakpoints

export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
} as const

export type BreakpointKey = keyof typeof BREAKPOINTS
